appModule.service('ftAppService', function() { });